module.exports = __webpack_public_path__ + "img/inventoryHeader.811b1497.svg";